import {CALL_API} from 'redux-api-middleware';
import {
  API_USR_GET_ENTITIES_REQUEST,
  API_USR_GET_ENTITIES_SUCCESS,
  API_USR_GET_ENTITIES_FAILURE,
} from 'common/types';
import {ENDPOINT_USER} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeaderNoCT} from 'common/utils';

export default {
  getUserEntities: (token) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_USER}entities`,
        headers: commonJwtHeaderNoCT(),
        method: 'GET',
        types: [
          API_USR_GET_ENTITIES_REQUEST,
          API_USR_GET_ENTITIES_SUCCESS,
          API_USR_GET_ENTITIES_FAILURE,
        ],
      },
    };
  },
};
